import DefaultPageLayout from "../../Layouts/DefaultPageLayout";
import React, {useState} from "react";
import styles from './LoginPage.module.scss';
import {StyledText} from "Components/Text";
import Box from "Components/Box";
import InputLabel from "Components/InputLabel";
import {ControlledInput} from "Components/Input";
import Gap from "Components/Gap";
import Button from "Components/Button";
import {useTranslation} from "react-i18next";
import {useForm} from "react-hook-form";
import {resetPassword} from "FirebaseSetup/auth";
import useToast from "Hooks/useToast";
import {useNavigate} from "react-router-dom";
import OnboardingBoxContent from "Features/Onboarding/Components/OnboardingBoxContent";

const ResetPasswordPage = () => {

    const navigate = useNavigate();
    const { showSuccessToast } = useToast();

    const sendResetPasswordEmail = async (data: any) => {
        setLoading(true);

        try {
            await resetPassword(data.email);
        } finally {
            showSuccessToast(t('auth:resetPassword.emailSent'));

            setLoading(false);
        }
    }

    const { t } = useTranslation();
    const [loading, setLoading] = useState<boolean>(false)

    const {control, handleSubmit} = useForm();

    return (
        <DefaultPageLayout contentMaxWidth={1440}>
            <div className={styles.container}>

                <div className={styles.headline}>
                    <StyledText type={"Headline"} weight={"Bold"} color={"secondary"}>
                        {t('resetYourPassword')}
                    </StyledText>
                    <StyledText type={"Body"}>
                        {t('resetYourPasswordDescription')}
                    </StyledText>
                </div>

                <Box style={{width: 840}}>
                    <form onSubmit={handleSubmit(sendResetPasswordEmail)} className={styles.content}>
                        <OnboardingBoxContent content={(
                            <>
                                <div>
                                    <InputLabel required>
                                        {t('email')}
                                    </InputLabel>
                                    <ControlledInput name={'email'} placeholder={t('yourEmail')} control={control} rules={{required: true}}/>
                                </div>
                            </>
                        )} buttons={(
                            <Gap size={"small"} className={"flex space-between"}>
                                <Button text={t('backToLogin')} type={"button"} outline onClick={() => navigate('/login')} />
                                <Button text={t('sendResetPasswordEmail')} type={"submit"} state={loading ? "Loading" : "None"}/>
                            </Gap>
                        )} />
                    </form>
                </Box>
            </div>
        </DefaultPageLayout>
    )
}

export default ResetPasswordPage
